import React from "react";
import CreatableSelect from "react-select/creatable";

const MultiValueSelect = ({
  label,
  name,
  onChange,
  defaultValue,
  labelStyles,
}) => {
  return (
    <div className="form-group">
      <label style={{ fontWeight: "bold", ...labelStyles }} htmlFor={name}>
        {label}
      </label>

      <CreatableSelect
        isMulti
        defaultValue={defaultValue}
        name
        onChange={onChange}
      />
    </div>
  );
};

export default MultiValueSelect;
